import styled from '@emotion/styled';


export const ImageInfoRoot = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(1)} ${theme.spacing(3)};
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.neutrals.grey1};
    text-align: center;

    > a {
      width: 100%;
      text-decoration: none;
      color: ${theme.colors.brand.light};
      &:active {
        text-decoration: underline;
        color: ${theme.colors.brand.darker};
      }
      > div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  `}
`;
